import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7ffb9b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "contact",
  name: "contact",
  class: "section-background-first"
}
const _hoisted_2 = { class: "contact" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "联系我们", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, "现在咨询开户，免费赠送100+体验短信！", -1))
const _hoisted_5 = { class: "contact-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_card_view = _resolveComponent("contact-card-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_contact_card_view, {
          src: _ctx.randomList.img,
          title: _ctx.randomList.title,
          contactNumber: _ctx.randomList.contactNumber,
          href: _ctx.randomList.href
        }, null, 8, ["src", "title", "contactNumber", "href"])
      ])
    ])
  ]))
}